import type { PropsWithChildren, MouseEvent } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";

const LINK_COLOR = colorsPalettes.blue[400];

type Props = PropsWithChildren<{
    tooltipContent: string;
    className?: string;
    overviewLink?: string;
    onClick?: (event: MouseEvent<HTMLSpanElement>) => void;
    dataAutomation?: string;
}>;

const LeadText = ({ className, tooltipContent, overviewLink, onClick, dataAutomation, children }: Props) => {
    return (
        <a
            href={overviewLink}
            target="_blank"
            className={className}
        >
            <TruncatedTextWithTooltip
                fontVariant="input2"
                color={LINK_COLOR}
                cursor="pointer"
                data-automation={dataAutomation}
                whenHover={{
                    color: LINK_COLOR,
                }}
                tooltipProps={{
                    content: tooltipContent,
                }}
                onClick={onClick}
            >
                {children}
            </TruncatedTextWithTooltip>
        </a>
    );
};

export default LeadText;
